import { useRecoilValue } from 'recoil';
import { usePrevious } from 'react-delta';

import { viewState } from 'components/common/Managers/ViewStateManager.state';

export const useDidViewChange = () => {
  const view = useRecoilValue(viewState);
  const prevView = usePrevious(view);

  return {
    didViewChange: Boolean(prevView && prevView.name !== view.name),
    isNewView: prevView?.name !== view.name,
  };
};
